import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { PropostaPage } from '@/features/proposta/brasil/pages/criar-proposta'
import PropostaListarProdutos from '@/features/proposta/brasil/pages/listar-produtos'

const PropostaAtivaPage = lazy(() =>
  import('@/features/proposta/brasil/pages/proposta-ativa').then((module) => ({
    default: module.PropostaAtivaPage,
  })),
)

const PropostaDocumentosPage = lazy(() =>
  import('@/features/proposta/brasil/pages/documentos').then((module) => ({
    default: module.PropostaDocumentosPage,
  })),
)

const RevisarPage = lazy(() =>
  import('@/features/proposta/brasil/pages/revisar').then((module) => ({
    default: module.RevisarPage,
  })),
)

const DuplicarPropostaResumoPage = lazy(() =>
  import('@/features/proposta/brasil/pages/duplicar').then((module) => ({
    default: module.DuplicarPropostaResumoPage,
  })),
)

const EnvioDocumentosPropostaPage = lazy(() =>
  import('@/features/proposta/brasil/pages/envio-documentos').then((module) => ({
    default: module.EnvioDocumentosPropostaPage,
  })),
)

export const brasilPropostaRoutes: RouteObject[] = [
  {
    path: 'proposta',
    children: [
      {
        index: true,
        element: <PropostaPage />,
      },
      {
        path: 'selecao-produtos',
        element: <PropostaListarProdutos />,
      },
      {
        path: ':numero',
        element: <PropostaAtivaPage />,
      },
      {
        path: ':numero/documentos',
        element: <PropostaDocumentosPage />,
      },
      {
        path: ':numero/documentos/envio/:pessoaId',
        element: <EnvioDocumentosPropostaPage />,
      },
      {
        path: ':numero/revisar',
        element: <RevisarPage />,
      },
      {
        path: ':numero/duplicar',
        element: <DuplicarPropostaResumoPage />,
      },
    ],
  },
]
